import { min } from "class-validator"
import { FgPriceListCategoryEnum } from "../enums/fg-pricelist-category-enum"

export class FgPriceListRequest{
    id:number
    productId:number
    category:FgPriceListCategoryEnum
    // packStyleId:number
    // price:number
    createdUser:string
    updatedUser:string
    // packStyle:string
    product:string
    isActive:boolean
    versionFlag:number
    highPrice:number
    minPrice:number
    midPrice:number
    updatedAt?:Date
    constructor(
        id:number,
        productId:number,
        category:FgPriceListCategoryEnum,
        // packStyleId:number,
        // price:number,
        createdUser:string,
        updatedUser:string,
        // packStyle:string,
        product:string,
        isActive:boolean,
    versionFlag:number,
    highPrice:number,
    minPrice:number,
    midPrice:number,
    updatedAt?:Date

    ){
        this.id=id
        this.productId=productId
        this.category=category
        // this.packStyleId=packStyleId
        // this.price=price
        this.createdUser=createdUser
        this.updatedUser=updatedUser
        // this.packStyle=packStyle
        this.product=product
        this.versionFlag = versionFlag
        this.isActive = isActive
        this.midPrice = midPrice
        this.minPrice = minPrice
        this.highPrice = highPrice
        this.updatedAt=updatedAt
    }
}
export class FgPriceListRequestDto{
    data:FgPriceListRequest[]
    user:string

constructor(
    data:FgPriceListRequest[],
    user:string 
){
    this.data = data
    this.user = user
}}